// extracted by mini-css-extract-plugin
export var Grey = "LargeCards-module--Grey--d7403";
export var cardImage = "LargeCards-module--card-image--2aef2";
export var cardType = "LargeCards-module--card-type--bf75e";
export var container = "LargeCards-module--container--aedcf";
export var cta = "LargeCards-module--cta--cec07";
export var description = "LargeCards-module--description--526bf";
export var fullImage = "LargeCards-module--full-image--34f92";
export var grid = "LargeCards-module--grid--35e4b";
export var pad = "LargeCards-module--pad--5831c";
export var postCard = "LargeCards-module--post-card--ec8cf";
export var postCardLink = "LargeCards-module--post-card-link--bc2f5";
export var postLink = "LargeCards-module--post-link--a47b5";
export var shortText = "LargeCards-module--short-text--74791";
export var title = "LargeCards-module--title--4abd1";